<template>
    <div class="row">
        <div class="col-3 card-col">
            <Card class="mt-0 mb-3 p-3">
                <Jumbotron>
                    <div class="d-flex mt-2">
                        <img src="../assets/svg/flag.svg" alt="" srcset="" width="30" class="mb-3" />
                        <h4 class="heading ms-3">Evaluation Center</h4>
                    </div>
                    <p class="sub-heading mb-2">
                        Evaluation Center helps you to evaluate employee for the specific Training, select and evaluate training by
                        respective order.
                    </p>
                    <div class="d-flex gap-2">
                        <!-- <Button
                            label="Create"
                            @onClick="toggleCreateTrainingModal()"
                            class="qb-btn qb-btn-primary-md my-2 w-100"
                        /> -->
                        <Button
                            label="Create Evaluation Template"
                            @onClick="toggleTemplateModal"
                            class="qb-btn qb-btn-outline-md my-2 w-100"
                        />
                    </div>
                </Jumbotron>
                <!-- <Button  class="qb-btn qb-btn-primary-sm" /> -->
            </Card>
            <Card class="p-2 card-1">
                <SearchDropDown
                    label="Select Training *"
                    :selectLabel="selectedTraining.name || 'search training'"
                    placeholder="Enter Trainer Name to search"
                    @callBackValue="handleTrainingChange"
                    v-model="trainingSearchTerm"
                    :items="Trainings"
                />
            </Card>
        </div>
        <Card class="col-6 card-col">
            <router-view></router-view>
            <div v-if="!selectedTraining.name" class="d-flex justify-content-center my-5">
                <div class="info d-flex gap-3 p-3 mt-2 mb-0 align-items-center justify-content-center">
                    <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div>
                    <p class="my-0 fade-text">Select any Training</p>
                </div>
            </div>
        </Card>

        <Card class="col-3 card-col"> 
            <div>
                <!-- <Button label="Download Report" class="qb-btn qb-btn-black-md" @onClick="download()"/> -->
            </div>

            <div v-if="taskScore.userData && user" class="p-2">
        <table class="table">
            <thead>
                <tr>
                <th>Task Name</th>
                <th>Score</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(data,index) in taskScore.userData" :key="index">
                    <td class="text-small">{{data.taskName}}</td>
                    <td class="text-small">{{data.score}}</td>
                </tr>
            </tbody>
        </table>
            </div>
            <div> <p class="task-select-toggle-text mx-auto" v-if="checkModuleAvailability">
                  Select the module to view tasks
                </p></div>
        </Card>

        <Modal @close="toggleTemplateModal" :modalActive="showTemplateModal">
            <h4>Create Template</h4>
            <hr class="my-1" />
            <div>
                <Input label="Template Name" v-model="template.name" class="my-1" />
                <Input label="Template Type" v-model="template.type" class="mb-1" />
                <h6 class="mb-1">Template Field</h6>

                <div class="d-flex gap-3">
                    <Input placeholder="Add Evaluation Field" v-model="field" class="mb-1" />
                    <Button label="Add Field" class="qb-btn qb-btn-primary-sm my-auto" @onClick="addField(field)" />
                </div>
                <div class="m-2">
                    <Badge
                        v-for="(data, index) in template.rowLabels"
                        :key="index"
                        :label="data"
                        class="badge-neon badge-neon-success-outline p-1 mx-1"
                    />
                </div>
            </div>
            <Button class="qb-btn qb-btn-primary-md mt-2" label="create" @onClick="createTemplate()" :disabled="!checkField" />
        </Modal>



        <vue-html2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    filename="Evaluation Report"
    :paginate-elements-by-height="1100"
    :pdf-quality="2"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width="800px"
    :manual-pagination="false"
    @hasDownloaded="hasDownloaded($event)"
    ref="html2Pdf"
>
    <section slot="pdf-content">
            <p>hello</p>
        </section>
</vue-html2pdf>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Badge from '../components/BadgeComponent.vue';
import Input from '../components/TextFieldComponent.vue';
import Modal from '../components/ModalComponent.vue';
import Button from '../components/ButtonComponent.vue';
import Card from '../components/CardComponent.vue';
import SearchDropDown from '../components/DropDownSearchComponent.vue';
// import {createdNameSpace} from "vuex";
import Vue from "vue"
import { createNamespacedHelpers } from 'vuex';
const {  mapGetters: workSheetMapGetters} = createNamespacedHelpers('WorkSheet');
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers('Training');
const {mapGetters:authMapGetters} = createNamespacedHelpers('Auth');
export default {
    name: 'EvaluationPage',
    data() {
        return {
            selectedTraining: {
                name: '',
                value: '',
            },
            template: {
                name: '',
                type: '',
                rowLabels: [],
            },
            field: '',
            trainingSearchTerm: '',
            showTemplateModal: false,
        };
    },
    components: {
        Card,
        SearchDropDown,
        Button,
        Modal,
        Input,
        Badge,
        VueHtml2pdf
    },
    methods: {
        ...trainingMapActions({
            getTrainingListOptionsForDropDown: 'GET_CREATED_TRAINING_LIST',
            getUsersForEnrolledTraining: 'GET_USERS_FOR_ENROLLED_TRAINING',
            createNewTemplate: 'CREATE_TEMPLATE',
            getUserEvaluation: 'SET_USER_IN_EVALUATION',
            getEvaluationTraining: 'SET_TRAINING_FOR_EVALUATION',
             getAllTemplate: 'GET_ALL_TEMPLATE',
        }),
        handleTrainingChange({ label, value }) {
            this.selectedTraining.name = label;
            this.selectedTraining.value = value;
            this.$router.push({
                name: 'UserList',
                params: { trainingId: value },
            });
            this.getUserEvaluation({ payload: null });
            this.getEvaluationTraining({ payload: label });
            this.getUsersForEnrolledTraining({ id: value });
        },
        toggleTemplateModal() {
            this.showTemplateModal = !this.showTemplateModal;
        },
        addField(name) {
            this.template.rowLabels.push(name);
            this.field = '';
        },
        createTemplate() {
            let payload = this.template;
            if(this.template.name && this.template.type && this.template.rowLabels.length > 0){
            this.createNewTemplate({
                payload,
                successCallback: (res) => {
                    console.log(res);
                    this.toggleTemplateModal();
                    this.getAllTemplate({name:''})
                    if(res.data.status==='OK'){
                        Vue.$toast.success("Template Created Successfully")
                    }
                    if(res.data.status==='ERROR'){
                        Vue.$toast.error(res.data.message)
                    }
                    this.template.name=''
                    this.template.type=''
                    this.template.rowLabels=[]
                },
                errorCallback: (err) => {
                    console.log(err);
                },
            });
            }
            else{
                Vue.$toast.error("Enter All the Fields")
            }
        },
         generateReport () {
            this.$refs.html2Pdf.generatePdf()
            
        },
        download(){
            this.generateReport()
        },
       
    },
    computed: {
        ...trainingMapGetters({
            Trainings: 'getTrainingListOptions',
            user: 'getUserInEvaluation',
            
        }),
        ...workSheetMapGetters({
            taskScore:'getTaskScore'
        }),
        ...authMapGetters({
            loggedInUser:'getUser'
        }),
         checkField(){
            const temp= this.template.name && this.template.type && this.template.rowLabels.length > 0
            return temp;
        }
    },
    watch: {
        trainingSearchTerm(name) {
            // console.log(name);
            this.getTrainingListOptionsForDropDown({userId:this.loggedInUser.userId,name})
        },
    },
    created() {
        this.getTrainingListOptionsForDropDown({ userId:this.loggedInUser.userId});
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.sub-heading {
    font-size: $font-size-sm;
    font-weight: 600;
}
.card-col {
    height: 640px;
}
.card-1 {
    height: 420px;
}
.employee-title {
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    margin-bottom: 0px;
}
.fade-text {
    color: $light-500;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
.info {
    background-color: #fff9e9;
    border-radius: 5px;
    width: max-content;
}
.fa-circle-exclamation {
    color: #fec12f;
}
.text-small{
    color: $light-600;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-1;
}
.task-select-toggle-text {
  color: $light-500;
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-top: 40px;
  width: fit-content;
}
</style>
